import { render, staticRenderFns } from "./sensitiveTermsPopup.vue?vue&type=template&id=79e86f70&scoped=true&"
import script from "./sensitiveTermsPopup.vue?vue&type=script&lang=js&"
export * from "./sensitiveTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./sensitiveTermsPopup.vue?vue&type=style&index=0&id=79e86f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e86f70",
  null
  
)

export default component.exports